import { render, staticRenderFns } from "./NodeEdit.vue?vue&type=template&id=504e70ed&scoped=true&"
import script from "./NodeEdit.vue?vue&type=script&lang=js&"
export * from "./NodeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504e70ed",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/var/apps/oil/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504e70ed')) {
      api.createRecord('504e70ed', component.options)
    } else {
      api.reload('504e70ed', component.options)
    }
    module.hot.accept("./NodeEdit.vue?vue&type=template&id=504e70ed&scoped=true&", function () {
      api.rerender('504e70ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Well/NodeEdit.vue"
export default component.exports